import React, { useState } from "react";
import styles from "./Footer.module.css";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope } from "react-icons/fa";
import { MdLocationOn, MdAccessTime } from "react-icons/md"; // Location & Clock Icons

const Footer = () => {
  const [email, setEmail] = useState("");
  const currentYear = new Date().getFullYear(); // Get current year

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert(`Thank you for subscribing with ${email}!`);
    setEmail(""); // Clear input after submission
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Column 1 - Who We Are */}
        <div className={styles.column}>
          <h3>WHO WE ARE</h3>
          <p>
            <strong>Faidika Real Estate Limited</strong> eading land investment company dedicated to providing prime plots in Kenya. 
            Our focus is on offering a diverse range of land sizes, including 1/8th acre, 1/4 acre, and full acre plots, 
            catering to both <strong>residential and investment needs</strong>.
          </p>
          
          <p>
          With a strong commitment to transparency, integrity, and professionalism, we ensure that every transaction is smooth 
          and secure, providing our clients with peace of mind and confidence in their investment.
          </p>
          <button className={styles.learnMore}>Learn More</button>
        </div>

        {/* Column 2 - Quick Links */}
        <div className={styles.column}>
          <h3>QUICK LINKS</h3>
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Our Projects</a></li>
            <li><a href="#">Contact</a></li>
            <li><a href="#">Client Testimonials</a></li>
            <li><a href="#">FAQs</a></li>
          </ul>

          {/* Cookie Notice Section */}
          <div className={styles.cookieNotice}>
            <h4>COOKIE NOTICE</h4>
            <p>
              We use cookies to enhance user experience and analyze site traffic. 
              View our <a href="#" className={styles.cookieLink}> Cookie Policy</a>.
            </p>
          </div>
        </div>

        {/* Column 3 - Newsletter Subscription & Contact Info */}
        <div className={styles.column}>
          <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
          <p>Get the latest property updates and investment insights.</p>
          <form onSubmit={handleSubscribe} className={styles.newsletterForm}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.emailInput}
            />
            <button type="submit" className={styles.subscribeButton}>Subscribe</button>
          </form>

          {/* Office Locations & Contact Info */}
          <div className={styles.contactInfo}>
            <div className={styles.contactRow}>
              <MdLocationOn className={styles.contactIcon} />
              <span>Main Office: Spur Mall, 2nd Floor, Room S07, Kimbo</span>
            </div>
            <div className={styles.contactRow}>
              <MdAccessTime className={styles.contactIcon} />
              <span>Monday - Friday: 8:00 AM - 5:00 PM</span>
            </div>
            <div className={styles.contactRow}>
              <MdAccessTime className={styles.contactIcon} />
              <span>Saturday: 9:00 AM - 1:00 PM</span>
            </div>
            <div className={styles.contactRow}>
              <FaPhone className={styles.contactIcon} />
              <span>+254 717 520 520</span>
            </div>
            <div className={styles.contactRow}>
              <FaEnvelope className={styles.contactIcon} />
              <span>info@faidikagroup.com</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Note */}
      <div className={styles.footerBottom}>
        <p>Faidika Real Estate your- Building Prosperity.</p>
      </div>

      {/* Copyright Section */}
      <div className={styles.copyright}>
        <p>&copy; {currentYear} Faidika Real Estate Limited |  
          <a href="#"> Privacy Policy </a> |  
          <a href="#"> Powered by GroundApp </a>
        </p>
        
        {/* Social Media Icons */}
        <div className={styles.socialIcons}>
          <a href="#" className={styles.icon}><FaFacebook /></a>
          <a href="#" className={styles.icon}><FaTwitter /></a>
          <a href="#" className={styles.icon}><FaInstagram /></a>
          <a href="#" className={styles.icon}><FaLinkedin /></a>
        </div>
      </div>
    </footer>
  );
};


export default Footer;
